// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oSAfCW8EpnoG3koUCkr2 .panel-title {
  font-size: 1rem; /* theme.fonts.size.body */
}

.oSAfCW8EpnoG3koUCkr2 .panel-title > a {
  cursor: pointer;
  display: block;
}

.oSAfCW8EpnoG3koUCkr2 .panel-body {
  padding: 10px;
}

.oSAfCW8EpnoG3koUCkr2 ul {
  padding-left: 0;
}
`, "",{"version":3,"sources":["webpack://./../../graylog2-server/graylog2-web-interface/src/components/event-definitions/common/HelpPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe,EAAE,0BAA0B;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":[":local(.helpPanel) .panel-title {\n  font-size: 1rem; /* theme.fonts.size.body */\n}\n\n:local(.helpPanel) .panel-title > a {\n  cursor: pointer;\n  display: block;\n}\n\n:local(.helpPanel) .panel-body {\n  padding: 10px;\n}\n\n:local(.helpPanel) ul {\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpPanel": `oSAfCW8EpnoG3koUCkr2`
};
export default ___CSS_LOADER_EXPORT___;
